import Footer from "components/footer/FooterAuthDefault";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";
import LogoIcon from "components/brand/LogoIcon";

export default function Auth() {
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "ltr";
  return (
    <div>
      <div className="relative float-right h-full min-h-screen w-full !bg-white dark:!bg-navy-900">
        <FixedPlugin />
        <main className={`mx-auto min-h-screen`}>
          <div className="relative flex">
            <div className="mx-auto flex min-h-full w-full flex-col justify-start pt-12 md:max-w-[75%] lg:h-screen lg:max-w-[1013px] lg:px-8 lg:pt-0 xl:h-[100vh] xl:max-w-[1383px] xl:px-0 xl:pl-[70px]">
              <div className="mb-auto flex flex-col pl-5 pr-5 md:pr-0 md:pl-12 lg:max-w-[48%] lg:pl-0 xl:max-w-full">
                <Routes>
                  {getRoutes(routes)}
                  <Route
                    path="/"
                    element={<Navigate to="/auth/sign-in" replace />}
                  />
                </Routes>
                {/* Sag panel */}
                <div className="absolute right-0 hidden h-full min-h-screen md:block lg:w-[49vw] 2xl:w-[44vw]">
                  <div
                    className="absolute flex h-full w-full flex-col items-center justify-center"
                    style={{
                      background: "linear-gradient(135deg, #991B1B 0%, #DC2626 40%, #B91C1C 70%, #DC2626 100%)",
                    }}
                  >
                    {/* Logo */}
                    <div className="mb-8 flex h-32 w-32 items-center justify-center rounded-3xl bg-white/15 backdrop-blur-sm">
                      <LogoIcon size={88} variant="white" />
                    </div>

                    <h2 className="font-outfit text-5xl font-extrabold text-white tracking-tight">MALİ AJANDA</h2>
                    <p className="mt-3 text-sm uppercase tracking-[0.25em] text-white/70">Admin Yönetim Paneli</p>

                    <div className="mt-16 rounded-2xl border border-white/20 bg-white/10 px-10 py-6 backdrop-blur-sm">
                      <p className="text-center text-sm text-white/80">Mali müşavirler için geliştirildi</p>
                      <p className="mt-1 text-center text-xl font-bold text-white">maliajanda.com</p>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
